// extracted by mini-css-extract-plugin
export default {"tooltip":"tQ-z","arrow":"uQ-z"};